import service from './service';
import { UrlBuilder } from './url-builder';

export const create = async (link, name) => {
  const builder = new UrlBuilder(`/links`);
  try {
    const response = await service.post(builder.toString(), link, name);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getLinks = async (payload) => {
  const builder = new UrlBuilder(`/get-links?mode=ALL`);
  try {
    const response = await service.post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const remove = async (id) => {
  const builder = new UrlBuilder(`/links/${id}`);
  console.log(id, builder.toString());

  const response = await service.remove(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};
